import { useTranslation } from 'react-i18next'

import CustomerInfoSection from './CustomerInfoSection/CustomerInfoSection'
import LocationInfoSection from './LocationInfoSection/LocationInfoSection'

const ParcelInfoCardTracking = ({ senderAddress, destinationAddress, customerEmail }) => {
  const { t } = useTranslation()

  return (
    <>
      <LocationInfoSection title={t('Origen')} address={senderAddress} />
      <CustomerInfoSection title={t('Destino')} address={destinationAddress} email={customerEmail} />
    </>
  )
}

export default ParcelInfoCardTracking
